(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/header-portal/components/user.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/header-portal/components/user.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$ticket_partner$c = svs.ticket_partner.constants.routes,
  LOGIN = _svs$ticket_partner$c.LOGIN,
  COMPANY_DETAILS = _svs$ticket_partner$c.COMPANY_DETAILS;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
svs.ticket_partner.sharedComponents.headerPortal.components.TEXTS = {
  LOGGED_IN: 'Inloggad',
  NOT_LOGGED_IN: 'Företagsinloggning'
};
const User = () => {
  const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.headerPortal.components.TEXTS,
    LOGGED_IN = _svs$ticket_partner$s.LOGGED_IN,
    NOT_LOGGED_IN = _svs$ticket_partner$s.NOT_LOGGED_IN;
  const _svs$ticket_partner$u = svs.ticket_partner.useUserContext(),
    isLoggedIn = _svs$ticket_partner$u.isLoggedIn,
    companyDetailsPromise = _svs$ticket_partner$u.companyDetailsPromise;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    userTitle = _useState2[0],
    setUserTitle = _useState2[1];

  useEffect(async () => {
    if (isLoggedIn) {
      const _await$companyDetails = await companyDetailsPromise,
        companyDetails = _await$companyDetails.companyDetails;
      setUserTitle((companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.companyName) || LOGGED_IN);
    } else {
      setUserTitle(NOT_LOGGED_IN);
    }
  }, [isLoggedIn, companyDetailsPromise]);
  const handleOnClick = e => {
    e.preventDefault();
    const route = isLoggedIn ? COMPANY_DETAILS : LOGIN;
    location.href = "".concat(location.origin, "/").concat(svs.core.data.baseUrl + route);
  };
  return React.createElement(IconButton, {
    "aria-controls": "navigation-menu-user",
    className: "nav-user",
    onClick: handleOnClick
  }, React.createElement("span", {
    className: "nav-user-title"
  }, userTitle), React.createElement(Icon, {
    className: "icon icon-default",
    icon: "user"
  }));
};
svs.ticket_partner.sharedComponents.headerPortal.components.User = User;

 })(window);